import * as React from 'react';
import { connect } from 'react-redux';
import { fetchOrdenes, setFiltroOrdenes } from '../../../actions/ordenesActions';
import { fetchExportarOrdenesApi } from '../../../api/axios';
import { limpiarFiltros } from '../../../actions/generalActios';
import { fetchSellersFilter } from '../../../actions/sellersActions';
import FiltroOrdenes from '../../Ordenes/FiltroOrdenes';
import { toast } from 'react-toastify';
import { filtroMedioMes } from '../../../utilities/fechasFiltro';
import MiniSpinner from "../../General/MiniSpinner";
import BigSpinner from "../../General/BigSpinner";
import { exportToExcel } from '../../../components/General/Excel/ExcelExportHelper';
const fechaFiltro = filtroMedioMes();

class ExportarOrdenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            datosExcelFormateados: null,
            hideSpinner: true,
            request: {
                idSeller: this.props.idSeller,
                cantidadPagina: 10,
                numeroPagina: 1,
                idOrden: "",
                documento: "",
                nombre: "",
                apellido: "",
                fechaDesde: fechaFiltro.desde,
                fechaHasta: fechaFiltro.hasta,
                entidadOrdenamiento: 1
            },
            cantidadOrdenes: 0,
            archivoExcel: "",
            loadingExport: false,
        };
        const { isCategory, isAdminMod } = this.props.userType;
        this.allowSearchBySeller = isCategory || isAdminMod;
    }

    componentDidMount() {
        this.props.ordenes.cantidadTotal = 0;

        let estadoInicioFiltraPor_Moderador = { ...this.state.request, idSeller: "" }
        let request = this.props.filtroOrdenes;

        if (this.props.emptyFiltro.ordenes) {
            if (this.allowSearchBySeller) {
                this.props.setFiltroOrdenes(estadoInicioFiltraPor_Moderador);
                this.setState({ request: estadoInicioFiltraPor_Moderador });
            } else {
                this.props.setFiltroOrdenes(this.state.request);
            }
        } else {
            request.numeroPagina = 1;
            this.props.setFiltroOrdenes(request);
            this.setState({ request: request });
        }

        if (this.allowSearchBySeller) {
            this.props.fetchSellersFilter({
                Descripcion: "",
                Page: 1,
                PageSize: 100
            });
        }
    }

    updateRequest = (request) => {
        this.setState({
            hideSpinner: false, cantidadOrdenes: 0 });

        if (!this.allowSearchBySeller && typeof request.idSeller === 'undefined') {
            request.idSeller = this.props.idSeller;
        }

        let params = { ...this.state, request: request };

        this.setState({
            request: params.request,
            currentPage: params.request.numeroPagina,
            datosExcelFormateados: null
        });

        this.props.setFiltroOrdenes(params.request);

        let filtroOrdenes = request;
        let paramsOrdenes = {
            idSeller: request.idSeller === "" ? null : parseInt(request.idSeller),
            fechaDesde: filtroOrdenes.fechaDesde,
            fechaHasta: filtroOrdenes.fechaHasta,
            idEstado: filtroOrdenes.idEstado === "" || isNaN(parseInt(filtroOrdenes.idEstado)) ? null : parseInt(filtroOrdenes.idEstado),
            idOrden: filtroOrdenes.idOrden === "" || isNaN(parseInt(filtroOrdenes.idOrden)) ? null : parseInt(filtroOrdenes.idOrden),
            documento: filtroOrdenes.documento === "" || isNaN(parseInt(filtroOrdenes.documento)) ? null : parseInt(filtroOrdenes.documento),
            apellido: filtroOrdenes.apellido === "" ? null : filtroOrdenes.apellido,
            skuMarket: filtroOrdenes.skuMarket === "" ? null : filtroOrdenes.skuMarket,
            TipoOrden: filtroOrdenes.TipoOrden === "" || isNaN(parseInt(filtroOrdenes.TipoOrden)) ? null : parseInt(filtroOrdenes.TipoOrden),
        }

        this.requestParaExportar(paramsOrdenes);
    }

    busquedaParaDescargarExcel = () => {
        this.setState({ datosExcelFormateados: null, hideSpinner: false });

        let idSeller = this.props.idSeller;

        if (this.allowSearchBySeller) {
            if (this.props.filtroOrdenes.idSeller !== "") {
                idSeller = parseInt(this.props.filtroOrdenes.idSeller);
            } else {
                idSeller = null;
            }
        }

        let filtroOrdenes = this.props.filtroOrdenes;

        try {
            this.descargarArchivoExcel(this.state.archivoExcel, "Ordenes.xlsx");

            // Espera breve antes de ocultar el spinner (opcional, da feedback visual)
            setTimeout(() => {
                this.setState({ hideSpinner: true });
            }, 5000);
        } catch (e) {
            toast.error('No se pudo descargar el excel');
            return;
        }
    }

    requestParaExportar = async (request) => {
        this.setState({ loadingExport: true });

        let req = null;
        try {
            req = await fetchExportarOrdenesApi(request);
            this.setState({
                cantidadOrdenes: req.cantidadOrdenes || 0,
                archivoExcel: req.excel,
                hideSpinner: true,
            })

        } catch (err) {
            (err.response.data.errores)
                ? err.response.data.errores.forEach(error => toast.error(error))
                : toast.error('No se pudo obtener la información');

            this.setState({ hideSpinner: true });
            return;
        } finally {
            this.setState({ loadingExport: false });
        };

        //this.ordenarExcel(req);
    }

    descargarArchivoExcel = (base64Data, nombreArchivo) => {
        const link = document.createElement("a");
        link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`;
        link.download = nombreArchivo;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        //this.setState({ hideSpinner: true });
    };

    ordenarExcel = (ordenesResponse) => {
        let ordenes = ordenesResponse.ordenes
        let listaOrdenes = [];

        for (let index = 0; index < ordenes.length; index++) {

            var item = ordenes[index];
            let idOrdenAnterior;

            let fechaOrden = ""
            if (item.fecha !== null) {
                let fechaSplit = item.fecha.slice(0, 10).split('-');
                fechaOrden = `${fechaSplit[2]}-${fechaSplit[1]}-${fechaSplit[0]}`;
            }

            item.productos.map((p) => {

                let ordenMultipleProductos = false;

                if (idOrdenAnterior !== undefined) {
                    if (item.idOrden == idOrdenAnterior) {
                        ordenMultipleProductos = true;
                    }
                }

                let montoVenta = this.changeMonto(item.montoVenta);
                let precioUnitario = this.changeMonto(p.precioUnitario);

                let datoOrden = {
                    fecha: fechaOrden,
                    idOrden: item.idOrden,
                    cuitSeller: item.seller.cuit !== null ? item.seller.cuit : "",
                    nombreSeller: item.seller.descripcion !== null ? item.seller.descripcion : "",
                    dniCliente: item.cliente.documento !== null ? item.cliente.documento : "",
                    nombreApellidoCliente: (item.cliente.nombre !== null || item.cliente.apellido !== null) ? item.cliente.nombre + " " + item.cliente.apellido : "",
                    domicilioCliente: item.cliente.domicilio !== null ? item.cliente.domicilio : "",
                    codigoPostalCliente: item.cliente.codigoPostal !== null ? item.cliente.codigoPostal : "",
                    localidadCliente: item.cliente.localidad !== null ? item.cliente.localidad + " " + item.cliente.provincia : "" + " " + item.cliente.provincia,
                    estado: item.estado[0].descripcion !== null ? item.estado[0].descripcion : "",
                    montoVenta: ordenMultipleProductos ? "" : montoVenta,
                    tipoPublicacion: item.tipoPublicacion.tipo !== null ? item.tipoPublicacion.tipo : "",
                    comision: ordenMultipleProductos ? "" : item.montoComision,
                    nroPlan: item.pago.cupones.length > 0 ? item.pago.cupones[0].nroPlan : "",
                    binTarjeta: item.pago.cupones.length > 0 ? item.pago.cupones[0].primerosSeisDigitos : "",
                    nroCupon: item.pago.cupones.length > 0 ? item.pago.cupones[0].nroCupon : "",
                    idTransaccion: item.pago.cupones.length > 0 ? item.pago.cupones[0].idTransaccion : "",
                    adquiriente: item.pago.cupones.length > 0 ? item.pago.cupones[0].adquiriente : "",
                    nroPlan2: item.pago.cupones.length > 1 ? item.pago.cupones[1].nroPlan : "",
                    binTarjeta2: item.pago.cupones.length > 1 ? item.pago.cupones[1].primerosSeisDigitos : "",
                    nroCupon2: item.pago.cupones.length > 1 ? item.pago.cupones[1].NroCupon : "",
                    idTransaccion2: item.pago.cupones.length > 1 ? item.pago.cupones[1].idTransaccion : "",
                    adquiriente2: item.pago.cupones.length > 1 ? item.pago.cupones[1].adquiriente : "",
                    subfamilia: p.subfamilia.descripcion !== null ? p.subfamilia.descripcion : "",
                    producto: p.titulo !== null ? p.titulo : "",
                    cantidad: p.cantidad,
                    precioUnitario: precioUnitario,
                    skuSeller: p.sellerSku !== null ? p.sellerSku : "",
                    skuMarket: p.skuMarket !== null ? p.skuMarket : "",
                    idVendedorBoca: item.idVendedorBoca,
                    origenOrdenWeb: this.origenOrdenExcel(item.plataforma.codigo),
                    detalleEnvio: item.montoGastoEnvio == 0 ? "Con Envío Gratis" : "Sin Envío",
                    domicilioEntrega: item.entrega.entregaDomicilio.domicilio !== "" ? item.entrega.entregaDomicilio.domicilio : "",
                    cpEntrega: item.entrega.entregaDomicilio.codigoPostal != 0 ? item.entrega.entregaDomicilio.codigoPostal : "",
                    tipoEntrega: item.entrega.entregaSucursalCorreo.sucursal != null ? "Retira en " + item.entrega.entregaSucursalCorreo.sucursal : "Envío a domicilio",
                    sucursalSeleccionada: item.entrega.entregaSucursalCorreo.idSucursal != 0 ? item.entrega.entregaSucursalCorreo.idSucursal : "",
                    costoEnvio: item.montoGastoEnvio
                };

                idOrdenAnterior = datoOrden.idOrden;
                listaOrdenes.push(datoOrden);
            })
        }

        this.setState({
            datosExcelFormateados: listaOrdenes,
            hideSpinner: true
        })

        if (this.props.tipoUsuario === 1 || this.props.tipoUsuario === 2) {
            document.getElementById('btnDescargaExcel').click();
        } else {
            document.getElementById('btnDescargaExcelSeller').click();
        }
    }

    changeMonto = (num) => {
        if (typeof num === "string") {
            num = new Number(num);
        }

        let formattedNumber = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2, maximumFractionDigits: 2
        }).format(num);

        return formattedNumber;
    }

    origenOrdenExcel = (plataformaCodigo) => {
        switch (plataformaCodigo) {
            case 0:
                return 'Megatone'
            case 1:
                return 'Mega-Market'
            case 2:
                return 'Megatone-Express'
            default:
                return ""
        }
    }


    render() {
        let sizeArray = JSON.stringify(this.state.datosExcelFormateados);

        return (
            <section className="container" role="search">
                <div className="row page-titles">
                    <div className="col-12">
                        <div className="row justify-content-between align-items-center">

                            <div className="col-md-8 align-self-center">
                                <h4 className="text-themecolor color-rojo-megatone">Órdenes</h4>
                            </div>

                            <div className="col-12 col-md-auto">
                                <div className="row justify-content-center">
                                    <div className="col-auto button-group text-right d-block">
                                        {this.state.hideSpinner || sizeArray != "[]" && <MiniSpinner />}
                                    </div>

                                    <div className="col-12 col-md-auto button-group text-right">
                                        <button
                                            type="button"
                                            onClick={this.busquedaParaDescargarExcel}
                                            className="btn btn-sm btn-green"
                                            disabled={
                                                this.props.loadingOrdenes ||
                                                this.state.cantidadOrdenes === 0 ||
                                                this.state.cantidadOrdenes === undefined
                                            }
                                        >
                                            Descargar {this.state.cantidadOrdenes} órdenes
                                        </button>
                                        <button 
                                            id="btnDescargaExcel" 
                                            type="button" 
                                            hidden={true}
                                            onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Ordenes', 'Ordenes')}
                                        />
                                        <button 
                                            id="btnDescargaExcelSeller" 
                                            type="button" 
                                            hidden={true}
                                            onClick={() => exportToExcel(this.state.datosExcelFormateados, 'Ordenes', 'Ordenes')}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <FiltroOrdenes
                    filtro={this.props.filtroOrdenes}
                    updateRequest={this.updateRequest}
                    allowSearchBySeller={this.allowSearchBySeller}
                    onClearCantidad={() => this.setState({ cantidadOrdenes: 0 })}
                    loadingExport={this.state.loadingExport}
                />

                {this.props.loadingOrdenes && <BigSpinner />}
            </section>
        );
    }
}


const mapStateToProps = state => ({
    userType: state.general.userType,
    tipoUsuario: state.general.tipoUsuario,
    idSeller: state.general.idSeller,
    ordenes: state.ordenes.ordenes,
    loadingOrdenes: state.ordenes.loadingOrdenes,
    filtroOrdenes: state.ordenes.filtro,
    emptyFiltro: state.general.limpiar
});

export default connect(mapStateToProps, {
    fetchSellersFilter,
    limpiarFiltros,
    fetchOrdenes,
    setFiltroOrdenes
})(ExportarOrdenes);